import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/modules/authentication/context/AuthContext";
import {
  BadgeCheck,
  ChevronsUpDown,
  LogOut,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "./ui/sidebar";
import { cn } from "@/lib/utils";
import { UserType } from "@/modules/user/types/user.type";

export function NavUser() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { isMobile } = useSidebar();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  const getAvatarColor = (type: UserType) => {
    switch (type) {
      case UserType.ADMIN:
        return "bg-emerald-600";
      case UserType.AGENCY:
        return "bg-orange-600";
      case UserType.USER:
        return "bg-gray-600";
      default:
        return "bg-gray-600";
    }
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="h-10 bg-white hover:bg-gray-50 text-gray-700  rounded-full transition-all duration-300 group-data-[collapsible=icon]:h-10 group-data-[collapsible=icon]:w-10 group-data-[collapsible=icon]:px-0 group-data-[collapsible=icon]:justify-center p-1"
            >
              <Avatar className={cn("h-8 w-8 rounded-full", getAvatarColor(user?.type as UserType))}>
                <AvatarFallback className={cn("rounded-full  text-white font-semibold", getAvatarColor(user?.type as UserType))}
                >
                  {user?.fullName?.charAt(0) || "U"}
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:hidden">
                <span className="truncate font-medium text-gray-800 max-w-[150px]">
                    {user?.fullName?.length && user?.fullName?.length > 15 ? user?.fullName?.substring(0, 15) + "..." : user?.fullName || "User"}
                </span>
                <span className="truncate text-xs text-gray-500 max-w-[150px]">
                    {user?.email || "user@example.com"}
                </span>
              </div>
              <ChevronsUpDown className="ml-auto size-4 text-gray-400 group-data-[collapsible=icon]:hidden" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg bg-white border-gray-200"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <Avatar className={cn("h-8 w-8 rounded-lg", getAvatarColor(user?.type as UserType))}>
                  <AvatarFallback className={cn("rounded-lg text-white font-semibold", getAvatarColor(user?.type as UserType))}>
                    {user?.fullName?.charAt(0) || "U"}
                  </AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium text-gray-800">
                    {user?.fullName || "User"}
                  </span>
                  <span className="truncate text-xs text-gray-500">
                    {user?.email || "user@example.com"}
                  </span>
                </div>
              </div>
            </DropdownMenuLabel>

            <DropdownMenuSeparator className="bg-gray-200" />
            <DropdownMenuGroup>
              <DropdownMenuItem
                onClick={() => navigate("/account")}
                className="text-gray-700 hover:bg-emerald-50 hover:text-emerald-700 focus:bg-emerald-50 focus:text-emerald-700"
              >
                <BadgeCheck className="w-4 h-4 mr-2 text-emerald-500" />
                Tài khoản
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator className="bg-gray-200" />
            <DropdownMenuItem
              onClick={handleLogout}
              className=" hover:bg-red-50 hover:text-red-700 focus:bg-red-50 focus:text-red-700 "
            >
              <LogOut className="text-current w-4 h-4 mr-2" />
              Đăng xuất
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
